<template>
  <div>
    <h4>Anomalias</h4>
    <el-table
      :data="anomalies"
      style="width: 100%"
      empty-text="Sem dados"
      :border="true"
    >
      <el-table-column prop="mslink" label="ID" width="50" />
      <el-table-column prop="tipoAnamoliaDescricao" label="Descrição" />
    </el-table>
  </div>
</template>

<script>
import { getIpAnamaly } from "../../services/agiltec";
export default {
  name: "PostAnomalyComponent",
  props: ["ipId"],
  data() {
    return {
      anomalies: [],
    };
  },
  methods: {
    getData() {
      getIpAnamaly(this.ipId).then((response) => {
        this.anomalies = response.source;
      });
    },
  },
  onMounted() {
    this.getData();
  },
  watch: {
    ipId() {
      this.getData();
    },
  },
};
</script>

<style>
</style>